import { useDownloadFileMutation, useGetFileQuery } from 'services/file'
import { Loading } from './Loading'
import { Error } from './Error'
import { LoadingButton } from '@mui/lab'
import { downloadFile as downloadFileHandler } from 'utils/download-file'
import DownloadIcon from '@mui/icons-material/Download'

type Props = {
  fileId?: string
}

export const DownloadFile = ({ fileId }: Props) => {
  const {
    data: file,
    isLoading,
    isError,
  } = useGetFileQuery({ id: fileId ?? '' }, { skip: !fileId })

  const [downloadFile, { isLoading: isDownloadLoading }] = useDownloadFileMutation()

  const onClickDownload = () => {
    downloadFile({ id: fileId ?? '' }).then((blob) => {
      downloadFileHandler(blob, file?.originalName ?? '')
    })
  }

  if (isLoading) return <Loading fullPage={false} />
  if (isError) return <Error fullPage={false} />

  if (file === undefined) {
    return <>-</>
  }

  return (
    <LoadingButton onClick={onClickDownload} loading={isDownloadLoading}>
      <DownloadIcon />
      {file.originalName}
    </LoadingButton>
  )
}
